import { initPromo } from './promotion'
import { RULE_TYPE_NUMBER, RULE_TYPE_TRIGGER, RULE_TYPE_TIME } from './consts'

(function() {
  window.sbPromotion = initPromo
  window.sbPromotion.RULE_TYPE_NUMBER = RULE_TYPE_NUMBER;
  window.sbPromotion.RULE_TYPE_TRIGGER = RULE_TYPE_TRIGGER;
  window.sbPromotion.RULE_TYPE_TIME = RULE_TYPE_TIME;
})()
  